<template>
  <div class="pa-3">
    <LMap :zoom="map.zoom" :center="coordinate" :options="map.options" :style="{ height: '400px' }">
      <LTileLayer :url="map.url" :attribution="map.attribution" />
      <LMarker :lat-lng="coordinate" :icon="map.icon">
        <LTooltip v-if="$slots.address" :options="map.tooltipOptions">
          <slot name="address" />
        </LTooltip>
      </LMarker>
    </LMap>
    <p class="text-xs-center ma-0">
      {{ $t('asset_wise.location.latitude') }}/{{ $t('asset_wise.location.longitude') }}:
      <v-btn flat small @click="copyCoordinate()">
        {{ latitude }}, {{ longitude }}
        <v-icon right small>content_copy</v-icon>
      </v-btn>
      <input ref="coordinateTextInput" hidden type="text" :value="`${latitude}, ${longitude}`" />
    </p>
  </div>
</template>

<script>
import { latLng, icon, point } from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet'

export default {
  components: { LMap, LTileLayer, LMarker, LTooltip },
  props: {
    latitude: {
      type: Number,
      default: 0
    },
    longitude: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      map: {
        zoom: 18,
        options: {
          zoomSnap: 0.5
        },
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        icon: icon({
          iconUrl:
            'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik00ODAtNDgwcTMzIDAgNTYuNS0yMy41VDU2MC01NjBxMC0zMy0yMy41LTU2LjVUNDgwLTY0MHEtMzMgMC01Ni41IDIzLjVUNDAwLTU2MHEwIDMzIDIzLjUgNTYuNVQ0ODAtNDgwWm0wIDQwMFEzMTktMjE3IDIzOS41LTMzNC41VDE2MC01NTJxMC0xNTAgOTYuNS0yMzlUNDgwLTg4MHExMjcgMCAyMjMuNSA4OVQ4MDAtNTUycTAgMTAwLTc5LjUgMjE3LjVUNDgwLTgwWiIgZmlsbD0icmVkIiAvPjwvc3ZnPgo=',
          iconSize: [32, 32],
          iconAnchor: [16, 32]
        }),
        tooltipOptions: {
          permanent: true,
          direction: 'top',
          offset: point(0, -32)
        }
      }
    }
  },
  computed: {
    coordinate() {
      return latLng(this.latitude, this.longitude)
    }
  },
  methods: {
    copyCoordinate() {
      const textInput = this.$refs.coordinateTextInput
      textInput.select()
      textInput.setSelectionRange(0, textInput.value.length)
      navigator.clipboard.writeText(textInput.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/components/document/DocumentMap.vue